export default (icon, classes = '') => (`
    <svg class="icon icon-${icon} ${classes}">
        <use
            href="/svg/sprite.symbol.svg#${icon}"
            xlink:href="/svg/sprite.symbol.svg#${icon}"
        />
    </svg>
`);
